export function getDatesOfBirth(value) {
  return Object.values(value)
}
